<template>
  <div v-if="shouldRender">
    <div v-if="pinnedId !== null" :style="{ height: chartHeight }">
      <ChartLoadState
        :graph-data="graphData"
        :loading="loading"
        :errored="errored"
        :error-text="I18n.t('report.drawer.pinned.load_error')"
        :hide-x-axis-labels="!store.fullscreen"
        :compact-y-axis="!store.fullscreen"
      />
    </div>
    <div
      v-else
      class="
        tw-p-6 tw-text-sm tw-text-sf-neutral-light-1 tw-italic tw-text-center
      "
      data-testid="pinned-graph-card-empty"
    >
      {{ I18n.t('report.drawer.pinned.empty_state') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import ChartLoadState from '@app/application/report/components/chart-load-state.vue'
import { usePinnedGraphChart } from '@app/application/report/composables/use-pinned-graph-chart'
import { useReportGraphsDrawer } from '@app/application/report/store/use-report-graphs-drawer'
import { PINNED_CHART_HEIGHT_DEFAULT } from '@app/application/report/constants'
import useI18n from '@app/shared/vue/composables/use-I18n'

defineOptions({
  name: 'PinnedGraphCard',
})

interface Props {
  readOnly?: boolean
  chartHeight?: string
}

const props = withDefaults(defineProps<Props>(), {
  readOnly: false,
  chartHeight: PINNED_CHART_HEIGHT_DEFAULT,
})

const I18n = useI18n()

const store = useReportGraphsDrawer()
const { pinned, reportTemplateId, locale, locked } = storeToRefs(store)

const pinnedId = computed(() => pinned.value?.id ?? null)

const shouldRender = computed(
  () => pinnedId.value !== null || (!props.readOnly && !locked.value)
)

const { graphData, loading, errored } = usePinnedGraphChart(
  pinnedId,
  reportTemplateId,
  locale
)
</script>
